import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import { LOGGER_FACTORY_URL } from '../constants/loggingConstants';
import LoggingUtil from './LoggingUtil';

var LoggingConfig = /*#__PURE__*/function () {
  function LoggingConfig(logServiceUrl, appName, appVersion, cacheEnabled, cacheSize, cacheDeduplicationTimeMilliseconds) {
    _classCallCheck(this, LoggingConfig);

    this.logServiceUrl = logServiceUrl;
    this.appName = appName;
    this.appVersion = appVersion;

    if (!LoggingUtil.canPromise()) {
      this.cacheEnabled = false;
    } else this.cacheEnabled = cacheEnabled;

    this.cacheSize = cacheSize;
    this.cacheDeduplicationTimeMilliseconds = cacheDeduplicationTimeMilliseconds;
  }

  _createClass(LoggingConfig, null, [{
    key: "initialize",
    value: function initialize(config) {
      LoggingConfig._validateRequiredFields(config);

      return new LoggingConfig(config.logServiceUrl, config.appName, config.appVersion, config.cacheEnabled, config.cacheSize, config.cacheDeduplicationTimeMilliseconds);
    }
  }, {
    key: "_validateRequiredFields",
    value: function _validateRequiredFields(config) {
      if (!config.logServiceUrl) {
        throw new Error("Logging Server URL must be configured, please check documentation @ ".concat(LOGGER_FACTORY_URL, " for further details"));
      }

      if (!config.appName || !config.appVersion) {
        throw new Error("Application name and/or version must be configured, please check documentation @ ".concat(LOGGER_FACTORY_URL, " for further details"));
      }
    }
  }]);

  return LoggingConfig;
}();

export { LoggingConfig as default };